import { createContext, ReactNode, useContext } from "react";

interface DebugModeValue {
  debugEnabled: boolean;
  toggleDebug: () => void;
}

const DebugModeContext = createContext<DebugModeValue | undefined>(undefined);
const disabledDebugMode: DebugModeValue = { debugEnabled: false, toggleDebug: () => {} };

export function DebugModeProvider({ children }: { children: ReactNode }) {
  return <DebugModeContext.Provider value={disabledDebugMode}>{children}</DebugModeContext.Provider>;
}

export function useDebugMode() {
  const context = useContext(DebugModeContext);
  if (!context) throw new Error("useDebugMode requires DebugModeProvider");
  return context;
}
